<template>
    <div class="duty-edit-wrapper">
        <a-modal
            class="duty-edit-modal"
            :visible="visible"
            title="编辑"
            :width="1200"
            :maskClosable="false"
            :confirm-loading="loading"
            @cancel="handleCancel"
            @ok="handleSubmitEvent">
            <a-table ref="table" size="default" 
                :columns="columns" :dataSource="dataList" :pagination="false"
                :rowKey="record => record.id"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: handleSelectChange }">
                
                <template slot="test_progress" slot-scope="text, record">
                    <a-tag v-if="text == 1" color="green">是</a-tag>
                    <a-tag v-else-if="2" color="red">否</a-tag>
                </template>

                <template slot="hardware" slot-scope="text, record">
                    <a-tag v-if="text == 1" color="green">是</a-tag>
                    <a-tag v-else-if="2" color="red">否</a-tag>
                </template>

                <template slot="teaching_form" slot-scope="text">
                    <span v-if="text == 1">{{ $t('program.meeting_type1') /* 录播 */ }}</span>
                    <span v-if="text == 2">{{ $t('program.meeting_type2') /* 线上连接 */ }}</span>
                    <span v-if="text == 3">{{ $t('program.meeting_type3') /* 现场参会 */ }}</span>
                    <span v-if="text == 0">{{ $t('program.meeting_type4') /* 未确定 */ }}</span>
                </template>
                
                <template slot="follow_user_id" slot-scope="text, record">
                    <a-select placeholder="负责人" v-model="record.follow_user_id" style="width: 100%" allowClear>
                        <a-select-option v-for="item in listObj.fzr_list" :key="item.id" :value="item.id">{{item.real_name}}</a-select-option>
                    </a-select>
                </template>
            </a-table>

            <a-form :form="form">
                <a-form-item style="width:100%;" label="是否接受">
                    <a-radio-group v-decorator="['acceptance_state', { rules: [{ required: true, message: '请选择是否接受' }] }]">
                        <a-radio value="1">接受</a-radio>
                        <a-radio value="2">拒绝</a-radio>
                        <a-radio value="0">未回复</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item style="width:100%;" label="授权状态" v-show="form.getFieldValue('acceptance_state') == 1">
                    <a-radio-group v-decorator="['authorization_state', { rules: [{ required: form.getFieldValue('acceptance_state') == 1, message: '请选择是否接受' }] }]">
                        <a-radio value="1">同意</a-radio>
                        <a-radio value="2">拒绝</a-radio>
                        <a-radio value="0">未确认</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item style="width:100%;" label="授权签字" v-show="form.getFieldValue('acceptance_state') == 1">
                </a-form-item>

                <a-form-item style="width:100%;" :label="$t('program.meeting_type')" v-show="form.getFieldValue('acceptance_state') == 1">
                    <a-radio-group v-decorator="['teaching_form', { rules: [{ required: form.getFieldValue('acceptance_state') == 1, message: '请选择参会形式' }] }]">
                        <a-radio :value="1">{{ $t('program.meeting_type1') /* 录播 */ }}</a-radio>
                        <a-radio :value="2">{{ $t('program.meeting_type2') /* 线上连接 */ }}</a-radio>
                        <a-radio :value="3">{{ $t('program.meeting_type3') /* 现场参会 */ }}</a-radio>
                        <a-radio :value="0">{{ $t('program.meeting_type4') /* 未确定 */ }}</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item style="width:100%;" label="讲课视频完成状态" v-show="form.getFieldValue('acceptance_state') == 1">
                    <a-radio-group v-decorator="['video_status', { rules: [{ required: form.getFieldValue('acceptance_state') == 1, message: '请选择讲课视频完成状态' }] }]">
                        <a-radio value="1">已完成</a-radio>
                        <a-radio value="0">未完成</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item style="width:100%;" label="反馈意见">
                    <a-textarea v-decorator="['acceptance_advice', { rules: [{ required: true, message: '请输入反馈意见' }] }]"></a-textarea>
                    <template slot="extra">
                        <div class="color999">例如角色安排的特殊要求，无法出席会议的原因</div>
                    </template>
                </a-form-item>

                <a-form-item style="width:100%;" label="是否测试完成" v-show="form.getFieldValue('acceptance_state') == 1">
                    <a-radio-group v-decorator="['test_progress', { rules: [{ required: form.getFieldValue('acceptance_state') == 1, message: '请选择是否测试完成' }] }]">
                        <a-radio value="1">是</a-radio>
                        <a-radio value="2">否</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item style="width:100%;" label="声音/画面是否正常" v-show="form.getFieldValue('acceptance_state') == 1">
                    <a-radio-group v-decorator="['hardware', { rules: [{ required: form.getFieldValue('acceptance_state') == 1, message: '请选择声音/画面是否正常' }] }]">
                        <a-radio value="1">是</a-radio>
                        <a-radio value="2">否</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item style="width:100%;" label="确认电脑网络不换" v-show="form.getFieldValue('acceptance_state') == 1">
                    <a-radio-group v-decorator="['switch', { rules: [{ required: form.getFieldValue('acceptance_state') == 1, message: '请选择确认电脑网络不换' }] }]">
                        <a-radio value="1">是</a-radio>
                        <a-radio value="2">否</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item style="width:100%;" label="测试沟通备注" v-show="form.getFieldValue('acceptance_state') == 1">
                    <a-textarea v-decorator="['test_remarks', { rules: [{ required: false, message: '请输入测试沟通备注' }] }]"></a-textarea>
                </a-form-item>

                <a-form-item style="width:100%;" label="负责人" v-show="form.getFieldValue('acceptance_state') == 1">
                    <a-select v-decorator="['follow_user_id', { rules: [{ required: true, message: '请选择负责人' }] }]">
                    </a-select>
                </a-form-item>

                <a-form-item style="width:100%;" label="备注" v-show="form.getFieldValue('acceptance_state') == 1">
                    <a-textarea v-decorator="['remarks_admin', { rules: [{ required: false, message: '请输入备注' }] }]"></a-textarea>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
const fileds = ['acceptance_state', 'authorization_state', 'teaching_form',
'video_status', 'acceptance_advice', 'test_progress', 'hardware', 'switch',
'test_remarks', 'follow_user_id', 'remarks_admin']
import pick from 'lodash.pick'
export default {
    name: 'dutyEditModal',
    props: {
    },
    data() {
        return {
            visible: false,
            loading: false,
            form: this.$form.createForm(this),
            columns: [
                {
                    title: '日期',
                    dataIndex: 'meeting_date',
                    align: 'center',
                    customRender: (text, record) => {
                        return `${text} ${record.starttime_slot}-${record.endtime_slot}`
                    },
                    fixed: 'left',
                    width: 150
                },
                {
                    title: this.$t('program.meeting_hall'/*会场名称*/),
                    dataIndex: 'meeting_hall',
                    align: 'center',
                    width: 120
                },
                {
                    title: '角色/任务',
                    dataIndex: 'typename_cn',
                    align: 'center',
                    width: 130
                },
                {
                    title: '名称',
                    dataIndex: 'abstract_title',
                    align: 'center',
                    width: 100
                },
                {
                    title: '是否测试完成',
                    dataIndex: 'test_progress',
                    scopedSlots: { customRender: 'test_progress' },
                    align: 'center',
                    width: 100
                },

                {
                    title: '声音/画面是否正常',
                    dataIndex: 'hardware',
                    scopedSlots: { customRender: 'hardware' },
                    align: 'center',
                    width: 100
                },
                {
                    title: '直播/录播',
                    dataIndex: 'teaching_form',
                    scopedSlots: { customRender: 'teaching_form' },
                    align: 'center',
                    width: 100
                },
                {
                    title: '确认电脑网络不换',
                    dataIndex: 'switch',
                    scopedSlots: { customRender: 'switch' },
                    align: 'center',
                    width: 100
                },
                {
                    title: '负责人',
                    dataIndex: 'follow_user_id',
                    scopedSlots: { customRender: 'follow_user_id' },
                    align: 'center',
                    width: 150
                }
            ],
            dataList: [],
            selectedRowKeys: [],
            listObj: {},
            user_id: ''
        };
    },
    created () {
        fileds.forEach(v => this.form.getFieldDecorator(v))
    },
    methods: {
        handleSelectChange (keys) {
            this.selectedRowKeys = keys
        },
        showFun(id, info) {
            this.visible = true
            this.user_id = id || ''
            this.getDataList()
            this.form.setFieldsValue(pick(info, fileds))
            console.log(info)
            // this.getProgramFormList()
        },
        getProgramFormList() {
            this.$request.get({ url: 'getProgramFormList'}).then(res => {
                this.listObj = res.data;
            });
        },
        getDataList () {
            this.loading = true
            this.$request.get({ url: 'getUserProgressMultiple', data: { user_id: this.user_id } }).then((res) => {
                const { data } = res.data
                this.dataList = data
            }).finally(() => {
                this.loading = false
            })
        },
        handleSubmitEvent () {
            this.form.validateFields((err, values) => {
                if (!err) {
                    console.log(values)
                }
            })
        },
        handleCancel() {
            this.visible = false;
        }
    },
};
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-modal-body {
    max-height: 72vh;
    overflow-y: auto;
}
/deep/ .table-page-search-wrapper .ant-form-inline .ant-form-item {
    margin-bottom: 0px;
}
</style>